<template> 
    <div id='trace_list'>
        <template v-if="showPage == 0">
            <div class='search-input-wrap table_searchbar'>
                <el-row class='search-input-row'>
                    <el-col :span='span'>
                        <div>
                            <span class="title">源订单号：</span>
                            <el-select style="max-width:180px" filterable="filterable" clearable="clearable" allow-create  
                                :loading="orderLoading" :remote-method="remoteMethod5" remote="remote"
                                @visible-change='closeOrderList' v-model='searchForm.orderCode' size='small'
                                maxlength='16' placeholder='订单号' @change='orderSelectChange'
                                @keyup.enter.native='search' popper-class='width180'>
                                <el-tooltip placement="right" v-for="item in orderOptions" :key="item.id" :content="item.label" :disabled="(span==5?item.label.length<=17:item.label.length<=17)">
                                    <el-option :value="item.label" :label="item.label"></el-option>
                                </el-tooltip>
                                <div v-if="orderOptions.length > 48" class="search-keyword" style="text-align:center">
                                    <span style="font-size:12px;color:red">只显示前50条结果，请完善搜索关键字</span>
                                </div>
                            </el-select>
                        </div>
                    </el-col>

                    <el-col :span="W?span:6">
                        <div>
                            <span class="title">工单号：</span>
                            <el-input @keyup.enter.native='search' placeholder='工单号' v-model='searchForm.productionBatchCode'
                                style="max-width:180px"></el-input>
                        </div>
                    </el-col>

                    <el-col :span="W?span:6">
                        <div>
                            <span class="title">物料编码：</span>
                            <el-input @keyup.enter.native='search' placeholder='物料编码' v-model='searchForm.materialCode'
                                style="max-width:180px"></el-input>
                        </div>
                    </el-col>

                    <el-col :span='4'>
                        <div style="text-align:right">
                            <el-button size='mini' type='primary' icon="el-icon-search" @click='clickSearch'>查询
                            </el-button>
                            <el-button size='mini' icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <el-row class='tab'>
                <el-row class='table-wrap'>
                    <el-table :data='tableData' ref="refTable" @row-click="expandChange" tooltip-effect='dark'
                        :default-sort='defaultSort' @sort-change='sortChangeEvent'>

                        <el-table-column prop="productionBatchCode" label="工单号" show-overflow-tooltip></el-table-column>
                        <el-table-column prop='orderCode' class-name='paddingtop' label='源订单号' min-width='80' max-width="200" show-overflow-tooltip="show-overflow-tooltip">
                        </el-table-column>
                        <!-- min-width="180" -->
                        <el-table-column prop="materialCode" label="物料编码" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="materialName" label="物料名称" min-width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="itemType" :formatter="materialItemType" label="物料类型" min-width="120" show-overflow-tooltip></el-table-column>
                        <el-table-column prop='gmtCreate' label='创建时间' min-width='100' max-width="180" sortable="custom"
                            :formatter='$commonUtil.changeToDate' show-overflow-tooltip="show-overflow-tooltip">
                        </el-table-column>

                        <el-table-column prop='gmtModified' label='更新时间' min-width='100' max-width="180"
                            sortable="custom" :formatter='$commonUtil.changeToDate'
                            show-overflow-tooltip="show-overflow-tooltip">
                        </el-table-column>

                        <el-table-column label="操作" class-name='paddingtop' fixed="right" width="280" align="left">
                            <template slot-scope="scope">
                                <el-button @click="showDetail(scope.row)" type="text" size="small">订单生产追溯
                                </el-button>
                            </template>
                        </el-table-column>

                    </el-table>
                </el-row>
                <div class="page" v-if="page.isShow">
                    <div class="total_page">
                        <span>共{{page.total}}条{{page.pageSize}}条/页</span>
                    </div>
                    <div style="margin-top:10px;text-align:right; margin-bottom:20px;">
                        <el-pagination background="background" layout="prev, pager, next" :total="page.total"
                            @current-change="pageChange" :current-page.sync="page.currentPage"></el-pagination>
                    </div>
                </div>
            </el-row>
        </template>
        <TraceDetail :rowData.sync="formDetail" :isShow.sync="showDetailView"></TraceDetail>
    </div>
</template>

<script>
import CommonUtils from '@/util/CommonUtils'
import TraceDetail from './TraceDetail.vue'

export default {
    name: 'TraceList',
    components: {
        TraceDetail
    },
    data() {
        return {
            showOrderRow: false,
            expands: [],
            spliteList: {},
            productionInfo: {
                dataList: []
            },
            formDetail: {},
            dataList: [],
            editForm: {},
            searchCopy: {},
            fristLoad: false,
            plannedRatio: 0,
            statusCount0: 0,
            statusCount2: 0,
            statusCount4: 0,
            statusCount5: 0,
            statusCount99: 0,
            statusCount7: 0,
            checked: true,
            rowData: true,
            exportInfo: {
                success: 0,
                fail: 0,
                url: null,
                total: 0
            },
            exportDialogVisible: false,
            W: false,
            searchConditionSpan: 24 / 4,
            searchForm: {
                orderId: '',
                orderCode: '',
                materialCode : '',
                productionBatchCode : "",
                productionPlanId: "",
            },
            isPostpone: null,
            tableData: [],
            orderType: 'DESC', //排序类型
            orderColumn: 'gmtCreate', //排序列
            defaultSort: {
                prop: 'gmtCreate',
                order: 'descending'
            }, //默认排序设置
            page: {
                isShow: false,
                total: 0,
                currentPage: 1,
                pageSize: 10
            },
            buttonSize: 'small', //按钮的大小
            showImportOrderView: false,
            showAddOrderView: false,
            showDetailView: false,
            orderLoading: false,
            orderOptions: [],
            deviceLoading: false,
            deviceOptions: [],
            workerLoading: false,
            productLoading: false,
            showPage: 0,
            Check: true,
            selectedOrder: null,
            comebackFlag: false,
            selectOrderName: '',
            options: [  //0-生产中 1-已完成 2-部分完成 3-已关闭 4-已排产 5-未排产 6-已取消  7-部分排产
                {
                    value: '5',
                    label: '未排产'
                },
                {
                    value: '7',
                    label: '部分排产'
                }, {
                    value: '4',
                    label: '已排产'
                }, {
                    value: '0',
                    label: '生产中'
                }, {
                    value: '2',
                    label: '部分完成'
                }, {
                    value: '1',
                    label: '已完成'
                }, {
                    value: '3',
                    label: '已关闭'
                }, {
                    value: '6',
                    label: '已取消'
                }
            ],
            searchStr:'',
            permission: JSON.parse(localStorage.getItem("permission"))
        }
    },

    mounted: function () {
        this.search(1)
        this.orderRemoteMethod();
        let w = document.documentElement.clientWidth || document.body.clientWidth;
        w >= 1900
            ? this.W = true
            : this.W = false

        window.onresize = () => {
            let w = document.documentElement.clientWidth || document.body.clientWidth;
            w >= 1900
                ? this.W = true
                : this.W = false
        }
    },

    computed: {
        span() {
            return this.W
                ? 5
                : 7
        },
        activeStatus() {
            if (this.$store.state.orderState == 5) {
                this.$store.commit('changeOrderState', null)
            }
            return this.$store.state.orderState
        },
        orderPageChange() {
            if (this.$store.state.orderPage.showPage == 1) {
                this.showPage = 0
                setTimeout(() => {
                    let data = CommonUtils.cloneObj(this.$store.state.orderPage)
                    // console.log(data);
                    this.showOrderProductView(data)
                    // console.log(this.showOrderProductView(data))
                    data.showPage = 0
                    this
                        .$store
                        .commit('changeOrderPage', data)
                }, 0)
            }
            return this.$store.state.orderPage.showPage
        },

    },
    methods: {

        selectable(row, index) {
            return row.canMrp
        },

        keepTwoDecimal(n){
			n = Number(n)
			return Math.round(n*100)/100
		},

        expandChange(row) {
            let index = this.expands.indexOf(row.id)
            if (index > -1) {
                this.expands.splice(index, 1)
            } else {
                this.expands.push(row.id)
            }
        },

        rowClass({ row, columnIndex }) {
            if (row.isUrgent > 0) {
                return { "background-color": "#fff0f0" }
            }
        },

        materialItemType(data){
            return data.itemType == 0?"产品":"零件";
        },

        async remoteMethod5(query) {
            this.orderLoading = true;
            this.searchStr = query
            await this.orderRemoteMethod(query)
            this.orderLoading = false
        },
        async closeOrderList(ev) {
            // if(!ev){
            //     if(this.searchStr){

            //         if(!this.searchForm.orderId){
            //             this.$set(this.searchForm,'orderId',this.searchStr)
            //         }else{
            //             let find = this.orderOptions.find(item=>item.label.includes(this.searchForm.orderId))
            //             if(!find){
            //                 this.$set(this.searchForm,'orderId',this.searchStr)
            //             }
            //         }
            //     }
            // }
        },

        parseStyle(rowData) {
            if (rowData.isPostpone == true) {
                return "red"
            } else if (rowData.isPostpone == false) {
                return ''
            }
        },

        deliverClass(i) {
            return i
                ? 'deliverClassA'
                : 'deliverClassB'
        },

        handlemyclass(row, column, rowIndex, columnIndex) {
            // log(row, column, rowIndex, columnIndex, 1111)
            if (row.columnIndex == 0) {

                return 'cellheader select-header'
            } else {
                return 'cellheader'
            }

        },
        orderStateChange(val) { },
        reload(pageNum, orderColumn, orderType) {
            if (orderColumn && orderType) {
                this.orderColumn = orderColumn
                this.orderType = orderType
                let order = ''
                if (orderType == 'DESC') {
                    order = 'descending'
                } else {
                    order = 'ascending'
                }
                this.defaultSort = {
                    prop: orderColumn,
                    order
                }
            }

            if (pageNum) {
                this.search(pageNum);
            } else {
                this.search(1);
            }
            this.$forceUpdate()
        },
        orderSampleDownload() { },
        showOrderProductView(row) {
            row.parseState = this.parseOrderState(row)
            this.selectedOrder = row;
            this.selectedOrder.pageNum = this.pageNum
            this.selectedOrder.orderColumn = this.orderColumn
            this.selectedOrder.orderType = this.orderType

            this.showPage = 1;
        },
        showProgress(row, column, cellValue, index) {
            let all = row.partCount;
            let finished = row.processedCount;
            finished = finished == null
                ? 0
                : finished;
            return (100 * finished / all).toFixed(2) + '%';
        },
        orderSelectChange(val) {
           
        },
        async orderRemoteMethod(query) {
            let { data } = await this
                .$RequestUtil
                .getAsync({
                    url: '/api/select/listOrder',
                    params: {
                        orderCode: query
                    }
                });
            this.orderOptions = data.filter(item => item.label);
        },
        importOrder() {
            this.showImportOrderView = true;
        },

        addOrder() {
            this.showAddOrderView = true;
        },
        showDetail(rowData) {
            this.showDetailView = true;
            console.log("rowData:" + JSON.stringify(rowData));
            this.formDetail = commonUtils.cloneObj(rowData)
        },
        pageChange(pageNum) {
            this.$set(this, 'searchForm', commonUtils.cloneObj(this.searchCopy));
            this.search(pageNum);
        },
        //排序改变事件
        sortChangeEvent(param) {
            console.log(param);
            let orderType = param.order;
            let orderColumn = param.prop;
            this.orderColumn = orderColumn;
            if (orderType == 'descending') {
                this.orderType = 'DESC';
            } else if (orderType == 'ascending') {
                this.orderType = 'ASC';
            } else {
                this.orderType = orderType;
                this.orderColumn = null
            }

            if (this.comebackFlag) {
                this.comebackFlag = false;
                console.log('排序', this.oldPageNum)
                if (this.oldPageNum) {
                    this.page.currentPage = this.oldPageNum
                }
                this.search(this.page.currentPage);

            } else {
                this.search(1);
            }
            this.page.currentPage = 1
        },
        //列表查询
        search(pageNum) {
            if (pageNum == null || pageNum instanceof KeyboardEvent) {
                pageNum = 1;
            }
            this.pageNum = pageNum
            let form = this.searchForm;

            let params = {
                materialCode: form.materialCode,
                productionBatchCode: form.productionBatchCode,
                orderCode: form.orderCode,
                pageNum: pageNum,
                pageSize: this.page.pageSize
            };
            this.$RequestUtil.get({
                url: '/api/order/listTraceBack',
                type: 'sync',
                params: params,
                success: (res) => {
                    if (res.msg != "success") {
                        this
                            .$message
                            .error(res.message);
                        return;
                    }
                    let nowTime = new Date().getTime()
                    this.showOrderRow = false
                    this.plannedRatio = res.data.plannedRatio
                    this.tableData = res.data;
                    //log(this.tableData)
                    this.page.total = res.totalPages;
                    if (this.tableData.length > 0) {
                        this.page.isShow = true;
                    }
                    if (this.page.total == 0 && this.fristLoad) {
                        this
                            .$message
                            .warning('查询不到符合条件的数据');
                    }
                    this.fristLoad = true
                }
            });
        },
        rowDataIs($event) {
            // alert($event);
            if ($event == true) {
                this.isPostpone = null
                //代表已延期和没有延期所有数据
                this.page.currentPage = 1
                this.search();
            } else if ($event == false) {
                this.isPostpone = 0
                //代表返回没有延期的数据
                this.page.currentPage = 1
                this.search();
            }
        },
        //清空查询条件
        clearSearch() {
            let form = this.searchForm;
            form.orderId = '';
            form.orderCode = '';
            form.materialCode = ''
            form.productionBatchCode = ""
        },
        clickSearch() {
            this.searchCopy = commonUtils.cloneObj(this.searchForm)
            this.page.currentPage = 1
            this.search(1);
        },
        parseOrderState(rowData) {
            let find = this
                .options
                .find(item => item.value == rowData.orderState)
            if (find) {
                return find.label
            } else {
                return ''
            }
        },

        postPone(rowData) {
            if (rowData.isPostpone == true) {
                return '是'
            } else {
                return '否'
            }

            // if(this.checked==true){   return '是' }else
            // if(this.checked==false&&rowData.isPostpone==false){  this.tableData=''
            //
            // } let find = this.options.find(item => item.value == rowData.orderState) if
            // (find) {   return find.label } else {   return '' }
        },

        parseOrderDisassemblyRatio: function (rowData) {
            if (rowData.disassemblyRatio != null) {
                return rowData.disassemblyRatio + '%';
            }
        },
        parseOrderProcessRatio: function (rowData) {
            if (rowData.processRatio != null) {
                return rowData.processRatio + '%';
            }
        },
    },

    watch: {
        showPage: function (newVal, oldVal) {
            // 返回
            if (newVal == 0 && oldVal != 0) {
                this.comebackFlag = true;
            }
        },
        'activeStatus'(old, newNum) {
            log('监听到', old, newNum)
        },
        'orderPageChange'(old, newNum) {
            log('监听到', old, newNum)
        }
    },
    filters: {
        showAttrValue(arr, name) {
            if (!arr) {
                return "";
            } else {
                let find = false;
                let tmp = "";
                arr.forEach(item => {
                    if (item.attrName == name && item.attrValue) {
                        tmp = item.attrValue;
                    }
                });
                return tmp;
            }
        },
    }
}
</script>

<style scoped="scoped">
.help {
    background: url("../../../static/img/help.png");
    width: 17px;
    height: 17px;
    display: inline-block;
    background-size: cover;
    margin-left: 4px;
    position: relative;
    top: 4px;
}

.show-icon {
    width: 14px;
    height: 14px;
    display: inline-block;
    background-size: cover;
    margin-left: 0;
    position: relative;
    top: 3px;
}

.warp-box {
    display: flex;
    justify-content: space-between;
    font-size: 14px;
    /* margin-right: 80px; */
}

.status-item {
    flex: 1;
    height: 60px;
    background: rgb(245, 247, 252);
    margin-right: 40px;
    line-height: 60px;
    text-align: center;
    cursor: pointer;
}

.warp-item1 {
    background: url("../../../static/img/left.png");
    background-size: 100% 60px;
    z-index: 2;
}

.warp-item2 {
    background: url("../../../static/img/center.png");
    background-size: 100% 60px;
    z-index: 2;
}

.warp-item3 {
    background: url("../../../static/img/right.png");
    background-size: 100% 60px;
    margin-right: 0;
    z-index: 2;
}

.status-warp {
    position: relative;
    flex: 8;
    display: flex;
    margin-right: 80px;
}

.line {
    position: absolute;
    width: 100%;
    height: 6px;
    background: rgb(245, 247, 252);
    left: 0;
    top: 27px;
    z-index: 1;
}

.active-item {
    background: rgb(64, 158, 255);
    color: #ffffff;
}

.active-item1 {
    background: url("../../../static/img/left-active.png");
    color: #ffffff;
    background-size: 100% 60px;
    z-index: 2;
}

.active-item2 {
    background: url("../../../static/img/center-active.png");
    color: #ffffff;
    background-size: 100% 60px;
    z-index: 2;
}

.active-item3 {
    background: url("../../../static/img/right-active.png");
    color: #ffffff;
    background-size: 100% 60px;
    margin-right: 0;
    z-index: 2;
}

.planed-ratio {
    font-size: 14px;
}

/* @media screen and (min-width:1400px) and (max-width: 1800px) */
@media screen and (min-width: 1400px) and (max-width: 1700px) {
    .warp-box {
        margin-right: 40px;
        font-size: 12px;
    }

    .status-warp {
        margin-right: 40px;
    }

    .status-item {
        margin-right: 40px;
    }

    .warp-item3 {
        margin-right: 0;
    }
}

@media screen and (min-width: 1000px) and (max-width: 1399px) {
    .planed-ratio {
        font-size: 11px;
        position: relative;
        top: 2px;
    }

    .help {
        width: 14px;
        height: 14px;
    }

    .warp-box {
        margin-right: 0;
        font-size: 12px;
    }

    .status-warp {
        margin-right: 25px;
        flex: 6;
    }

    .status-item {
        margin-right: 25px;
        line-height: 40px;
        height: 40px;
    }

    .warp-item1 {
        background-size: 100% 40px;
    }

    .warp-item3 {
        background-size: 100% 40px;
    }

    .warp-item2 {
        background-size: 100% 40px;
    }

    .active-item1 {
        background-size: 100% 40px;
    }

    .active-item2 {
        background-size: 100% 40px;
    }

    .active-item3 {
        background-size: 100% 40px;
    }

    .line {
        top: 17px;
    }

    .warp-item3 {
        margin-right: 0;
    }
}

.operateBtn-wrap {
    margin-top: 20px;
    margin-bottom: 10px;
}

.search-input-row {
    margin-top: 10px;
}

.search-input-wrap {
    margin-bottom: 20px;
}

.page {
    display: flex;
    justify-content: flex-end;
}

.total_page {
    margin-top: 20px;
    margin-right: 26px;
    color: #606266;
    font-size: 14px;
}

@media screen and (max-width: 1380px) {
    #orderMgt {
        height: auto;
        margin-bottom: 30px;
    }

    .page {
        display: flex;
        justify-content: flex-end;
        margin-bottom: 30px;
    }
}

.table_searchbar .title11 {
    color: #606266;
    font-family: NotoSansHans-Regula;
    font-size: 14px;
    width: 70px;
    display: inline-block;
    text-align: right;
}

.exprot_info {
    text-align: center;
}
</style>

<style>
.width180 {
    width: 180px;
}

.el-button--mini.is-round,
.table_searchbar .el-button--mini {
    padding: 7px 10px;
}

.select-header .cell {
    margin-left: 4px;
}

.bar-bg .el-progress-bar__outer {
    background: rgb(255, 86, 34);
}
.deliverClassA {
    max-width: 110px;
    text-align: center;
    padding: 8px 0;
    background: #e84e0f;
    color: #ffffff;
}
.deliverClassB {
    max-width: 110px;
    text-align: center;
}
.table-in-table td,
.table-in-table th.is-leaf {
    border-bottom: none;
}
.table-in-table .el-table--border::after,
.table-in-table .el-table--group::after,
.table-in-table::before {
    content: "";
    position: absolute;
    background-color: #ffffff;
    z-index: 1;
}

.table-in-table thead {
    color: #333;
}

#trace_list .table-in-table thead th {
    background-color: #e1ebf5 !important;
}
</style>


// WEBPACK FOOTER //
// src/views/trace/TraceList.vue